import { gql } from '@apollo/client';

const REQUEST_USER_PASSWORD_RESET_MUTATION = gql`
  mutation requestUserPasswordReset($input: RequestUserPasswordResetInput) {
    requestUserPasswordResetResult: requestUserPasswordReset(input: $input) {
      result
    }
  }
`;

export default REQUEST_USER_PASSWORD_RESET_MUTATION;
